import script from "./TiptapEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./TiptapEditor.vue?vue&type=script&setup=true&lang=js"

import "./TiptapEditor.vue?vue&type=style&index=0&id=4bb38073&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bb38073"]])

export default __exports__